import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Table, Button } from 'react-bootstrap';
import Moment from 'moment';
import Dialog from 'react-bootstrap-dialog';
import './QuestionSnippetQuestionTypesTable.css';
import TooltipButton from './TooltipButton';

Moment.locale('en');

class QuestionSnippetQuestionTypesTable extends Component {
    constructor(props) {
        super(props);
    }

    didConfirmDelete(questiontype) {
        this.props.onDelete(questiontype);
    }

    handleDeleteClicked(questiontype) {
        const { t } = this.props;

        this.dialog.show({
            title: t('Dialog.warning'),
            body: t('Dialog.sure_deletion'),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.didConfirmDelete(questiontype),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    componentDidMount() {}

    render() {
        const {
            t,
            uuid,
            pageUUID,
            playerUUID,
            questiontypes,
            snippet
        } = this.props;

        let questiontypeRows = questiontypes.map((questiontype, index) => {
            return (
                <tr>
                    <td width="20">{questiontype.id}</td>
                    <td>{questiontype.description}</td>
                    <td align="right">
                        {this.props.userIsAuthorized(this.props.user, [
                            'staff_super_admin',
                            'staff_admin',
                            'organisation_admin',
                            'organisation_user'
                        ]) ? (
                            <TooltipButton
                                id="deleteButton"
                                className="btn-danger"
                                tooltip={t(
                                    'QuestionSnippetQuestionTypesTable.deletequestiontype'
                                )}
                                onClick={() =>
                                    this.handleDeleteClicked(questiontype)
                                }
                            >
                                <em className="fa fa-trash" />
                            </TooltipButton>
                        ) : null}
                    </td>
                </tr>
            );
        });

        return (
            <div
                id="QuestionSnippetQuestionTypesTable"
                className="QuestionSnippetQuestionTypesTable"
            >
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />

                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th width="20">
                                {t('QuestionSnippetQuestionTypesTable.id')}
                            </th>
                            <th>
                                {t(
                                    'QuestionSnippetQuestionTypesTable.description'
                                )}
                            </th>
                            <th width="60">
                                <em className="fa fa-cog" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>{questiontypeRows}</tbody>
                </table>
            </div>
        );
    }
}

export default translate('translations')(QuestionSnippetQuestionTypesTable);
